import { Reducer } from 'redux';

import { UserInfoVm } from '@/types';

import { UserActionTypes } from './action-types';
import { initialState } from './constants';
import { UserReducerState as State } from './types';

export const userReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case UserActionTypes.FETCH_USER_INFO.SUCCESS:
      return { ...state, userInfo: action.payload };

    case UserActionTypes.UPDATE_USER_INFO.SUCCESS:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
        } as UserInfoVm,
      };

    case UserActionTypes.FETCH_USER_INFO.FAIL:
      return { ...state, userInfo: null };

    default:
      return state;
  }
};
